import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackMetric } from './telemetry';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/// If you want to start measuring performance in your app, pass a function
/// to log results (for example: reportWebVitals(console.log))
/// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  const properties: Record<string, string> = {
    id: metric.id,
  };

  if ('rating' in metric && typeof metric.rating === 'string') {
    properties.rating = metric.rating;
  }

  if ('navigationType' in metric && typeof metric.navigationType === 'string') {
    properties.navigationType = metric.navigationType;
  }

  trackMetric(`webvital_${metric.name}`, metric.value, properties);
});
